import { Layout, Menu, Dropdown, Button } from "antd";
import {
  DashboardOutlined,
  UserOutlined,
  TeamOutlined,
  ShoppingCartOutlined,
  MenuOutlined,
  ApartmentOutlined
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import logo from "../../assets/branding/Perpul background logo.jpg";
import { useAuth } from "../../store/AuthContext";
import styles from './Sidebar.module.css';

const { Sider } = Layout;

const Sidebar: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [isMobile, setIsMobile] = useState(false);
  const { hasPermission } = useAuth();

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleSelect = ({ key }: { key: string }) => {
    navigate(key);
  };

  const rawMenuItems = [
    hasPermission("dashboard.dashboard") ? {
      key: "/dashboard",
      icon: <DashboardOutlined />,
      label: t("dashboard")
    } : null,
    hasPermission("dashboard.Order") ? {
      key: "/orders",
      icon: <ShoppingCartOutlined />,
      label: t("orders"),
      children: [
        hasPermission("dashboard.Order") ? { key: "/orders/new", label: t("add_new_order") } : null,
        hasPermission("dashboard.Order.ordered") ? { key: "/orders/status/ordered", label: t("ordered") } : null,
        hasPermission("dashboard.Order.shipped") ? { key: "/orders/status/shipped", label: t("shipped") } : null,
        hasPermission("dashboard.Order.inStore") ? { key: "/orders/status/inStore", label: t("in_store") } : null,
        hasPermission("dashboard.Order.delivered") ? { key: "/orders/status/delivered", label: t("delivered") } : null
      ].filter(Boolean)
    } : null,
    hasPermission("dashboard.Customer") ? {
      key: "/customers",
      icon: <TeamOutlined />,
      label: t("customers")
    } : null,
    hasPermission("dashboard.city")
      ? {
        key: "/city",
        icon: <ApartmentOutlined />,
        label: t("city")
      }
      : null,
    hasPermission("report.dashboard") ? {
      key: "/report",
      icon: <UserOutlined />,
      label: t("report")
    } : null,
    hasPermission("dashboard.user") ? {
      key: "/users",
      icon: <UserOutlined />,
      label: t("users")
    } : null,
    hasPermission("dashboard.roles") ? {
      key: "/roles",
      icon: <TeamOutlined />,
      label: t("roles")
    } : null,
    {
      key: "/profile",
      icon: <UserOutlined />,
      label: t("profile")
    },
  ].filter(Boolean);

  const dropdownMenu = (
    <Menu
      onClick={handleSelect}
      items={rawMenuItems as any}
      className={styles.menuCustom}
    />
  );

  return isMobile ? (
    <div
      style={{
        padding: "8px 16px",
        display: "flex",
        alignItems: "center",
        background: "#27156B",
        borderRadius: "14px",
        margin: "10px",
        boxShadow: "0 4px 16px 0 rgba(39, 21, 107, 0.15)",
        zIndex: 1200, // Put zIndex here!
      }}
    >
      <img src={logo} alt="Logo" style={{ height: 40, marginRight: 14, borderRadius: 10, boxShadow: "0 2px 8px #1a0d3a25" }} />
      <Dropdown
        overlay={dropdownMenu}
        trigger={["click"]}
        getPopupContainer={triggerNode =>
          (triggerNode.parentNode as HTMLElement) || document.body
        }
      >
        <Button
          icon={<MenuOutlined />}
          style={{
            background: "#DF5515",
            color: "#fff",
            borderRadius: "8px",
            fontWeight: "bold",
            border: "none",
            boxShadow: "0 1px 6px #DF551520"
          }}
        >
          {t("menu")}
        </Button>
      </Dropdown>
    </div>

  ) : (
      <Sider width={210} className={styles.siderCustom}>
        <div className={styles.logoContainer}>
          <img src={logo} alt="Logo" style={{ height: 58, borderRadius: 14, boxShadow: "0 4px 24px #DF551540" }} />
      </div>
      <Menu
        mode="inline"
        theme="dark"
          defaultSelectedKeys={["/dashboard"]}
        onClick={handleSelect}
          items={rawMenuItems as any}
          className={styles.menuCustom}
          style={{
            fontSize: "16px",
            fontWeight: 500,
            background: "transparent"
          }}
      />
    </Sider>
  );
};

export default Sidebar;
